export const SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'Object captured as promise rejection with keys: noInternetConnection',
  'Server Error! Was unable to fetch required user data. Please contact your system administrator.',
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node",
  'Full authentication is required to access this resource',
  "DataCloneError: Failed to execute 'postMessage' on 'BroadcastChannel'"
] as const
